import { Payload } from "../../App";
import { obterDataAtualFormatada } from "../../utils/obterDataAtualFormatada";
import { saudacao } from "../../utils/saudacao";
import styles from "./Usuario.module.css";

const Usuario = ({ data }: { data: Payload }) => {
    return (
        <div className={styles.container}>
            <h1>
                {saudacao()}, {data.usuario.nome}!
            </h1>
            <p>{obterDataAtualFormatada()}</p>
            <Passagem
                referencia={
                    data.passagem.livro +
                    " " +
                    data.passagem.capitulo +
                    ":" +
                    data.passagem.versiculos
                        .sort((a, b) => a.n - b.n)
                        .map((v) => v.n)
                        .join(",")
                }
                texto={data.passagem.versiculos
                    .sort((a, b) => a.n - b.n)
                    .map((v) => v.t)
                    .join(" ")}
            />
            <Reflexao
                titulo="✦ Reflexão do dia"
                texto={data.passagem.reflexao}
            />
        </div>
    );
};

export interface PassagemProps {
    texto?: string;
    referencia?: string;
}

const Passagem = ({ texto, referencia }: PassagemProps) => {
    return (
        <div className={styles.passagem}>
            <blockquote className={styles.quote}>"{texto}"</blockquote>
            <p className={styles.reference}>{referencia}</p>
        </div>
    );
};

export interface ReflexaoProps {
    titulo?: string;
    texto?: string;
}

const Reflexao = ({ titulo, texto }: ReflexaoProps) => {
    return (
        <div className={styles.reflexao}>
            <p className={styles.title}>{titulo}</p>
            <p className={styles.text}>{texto}</p>
        </div>
    );
};

export default Usuario;
